import { createSlice } from '@reduxjs/toolkit';

const applicationSlice = createSlice({
  name: 'applications',
  initialState: {
    applications: [],
    currentApplication: null,
    stats: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    setApplications: (state, action) => { state.applications = action.payload; },
    setCurrentApplication: (state, action) => { state.currentApplication = action.payload; },
    setStats: (state, action) => { state.stats = action.payload; },
    addApplication: (state, action) => { state.applications.unshift(action.payload); },
    updateApplication: (state, action) => {
      const index = state.applications.findIndex(a => a._id === action.payload._id);
      if (index !== -1) state.applications[index] = action.payload;
    },
    setLoading: (state, action) => { state.isLoading = action.payload; },
    setError: (state, action) => { state.error = action.payload; },
    clearError: (state) => { state.error = null; },
  },
});

export const { setApplications, setCurrentApplication, setStats, addApplication, updateApplication, setLoading, setError, clearError } = applicationSlice.actions;
export default applicationSlice.reducer;
